import { Heading } from '@televet/kibble-ui/build/components/Heading';
import { Flex, HStack } from '@televet/kibble-ui/build/chakra';
import { Button } from '@televet/kibble-ui/build/components/Button';
import { Popover } from '@televet/kibble-ui/build/components/Popover';
import { Text } from '@televet/kibble-ui/build/components/Text';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSummaryProvider } from 'shared/providers/SummaryProvider';

interface SummaryButtonHiddenPopoverProps {
  anchor: React.ReactNode;
}

const SummaryButtonHiddenPopover = ({ anchor }: SummaryButtonHiddenPopoverProps): JSX.Element => {
  const [isSummaryButtonHiddenOpen, setIsSummaryButtonHiddenOpen] = useState<boolean>(false);
  const { isSummaryButtonHidden, updateSummaryButtonHidden } = useSummaryProvider();

  const prevIsSummaryPopoverOpenRef = useRef<boolean>(isSummaryButtonHidden);

  useEffect(() => {
    if (!prevIsSummaryPopoverOpenRef.current && isSummaryButtonHidden) {
      setIsSummaryButtonHiddenOpen(true);
    }

    prevIsSummaryPopoverOpenRef.current = isSummaryButtonHidden;
  }, [isSummaryButtonHidden]);

  const handleSummaryButtonHiddenUndoClick = useCallback((): void => {
    setIsSummaryButtonHiddenOpen(false);
    updateSummaryButtonHidden(false);
  }, [updateSummaryButtonHidden, setIsSummaryButtonHiddenOpen]);

  return (
    <Popover
      placement="bottom-start"
      size="lg"
      variant="default"
      isOpen={isSummaryButtonHiddenOpen}
      headerProps={{
        children: (
          <Flex align="center" justify="space-between" width="100%">
            <Heading size="sm">Button Hidden</Heading>
          </Flex>
        ),
        hideCloseButton: true,
      }}
      footerProps={{
        children: (
          <HStack width="100%" justify="space-between">
            <Button variant="tertiary" size="sm" onClick={handleSummaryButtonHiddenUndoClick}>
              Undo
            </Button>
            <Button variant="primary" size="sm" onClick={(): void => setIsSummaryButtonHiddenOpen(false)}>
              Got it
            </Button>
          </HStack>
        ),
        hideButtons: true,
      }}
      anchor={anchor}
    >
      <Text>Conversation Summary can still be found in the Actions menu.</Text>
    </Popover>
  );
};

export default SummaryButtonHiddenPopover;
